export default __webpack_public_path__ + "static/media/lv-active-bg.042d807b.webp";